export default __webpack_public_path__ + "static/media/avatar.157f088b.png";